// extracted by mini-css-extract-plugin
module.exports = {"root":"question-number_root__2ej9b","back-button":"question-number_back-button__vuhwt","backButton":"question-number_back-button__vuhwt"};